import captializeFirstLetter from "./captitalizeFirstLetter";

const labelValueGenerator = (arr, firstLetterUpperCase) =>
  arr?.map((ele) => ({
    label: firstLetterUpperCase ? captializeFirstLetter(ele) : ele,
    value: ele,
  }));

export default labelValueGenerator;
